import $ from "jquery";
// scroll

export const scrollLogic = (marginFromTop = 30) => {

  const scrollTimerMs = 800;

  const scrollUpBtn = document.querySelector(".scrollup");
  if (scrollUpBtn && (document.body.scrollHeight > 2000)) {
    scrollUpBtn.addEventListener("click", function () {
      $("html, body").animate({scrollTop: 0}, scrollTimerMs)
    });

    document.addEventListener('scroll', function () {
      // if (scrollUpBtn.classList.contains("scrollup--scrolling")) {
      //   return
      // }
      if (window.scrollY > 300) {
        if (!scrollUpBtn.classList.contains("scrollup--visible")) {
          scrollUpBtn.classList.add("scrollup--visible")
        }
      } else if (scrollUpBtn.classList.contains("scrollup--visible")) {
        scrollUpBtn.classList.remove("scrollup--visible")
      }
    }, {
      passive: true
    });
  }

  // scroll href buttons

  [].slice.call(document.querySelectorAll('a[href^="#"]')).forEach(function (element) {
    element.onclick = function (event) {
      const href = element.href.split("#")[1];
      if (href) {
        event.preventDefault();
        const elementToScroll = document.getElementById(href);
        if (elementToScroll) {
          $("html, body").animate({scrollTop: $(elementToScroll).offset().top - marginFromTop}, scrollTimerMs)
        }
      }
    }
  });
}
